import React from 'react';
import { useTranslate } from '@im/react-localization/localization/useTranslate';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/SearchOutlined';

type SelectSearchInputFieldProps = {
  error?: any;
  helperText?: string;
  isLoading?: boolean;
  onChange: any;
  onInputChange?: any;
  options: any[];
  value: any;
};

export default function SelectSearchInputField({
  error,
  helperText,
  isLoading,
  onChange,
  onInputChange,
  options,
  value,
}: Readonly<SelectSearchInputFieldProps>) {
  const translate = useTranslate();
  return (
    <>
      <Autocomplete
        clearOnBlur={true}
        fullWidth
        loading={isLoading}
        noOptionsText={translate('Common.NoRecord')}
        onChange={onChange}
        onInputChange={onInputChange}
        options={options}
        renderInput={(params) => (
          <TextField
            error={error}
            placeholder={translate('Common.Search')}
            {...params}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ padding: '0px' }}
          />
        )}
        value={value}
      />
      <FormHelperText
        error={error}
        sx={{
          fontSize: '12px !important',
          marginTop: '4px !important',
        }}
      >
        {helperText}
      </FormHelperText>
    </>
  );
}
